export default {
  namespaced: true,
  state: {
    soundIsMuted: !!+localStorage.getItem('soundIsMuted'),
    sideMenuIsActive: false,
    backdropOpenedTimes: 0,
    chatIsOpened: false,
    modalIsOpened: false,
  },
  getters: {
    getSoundIsMuted: (state) => state.soundIsMuted,
    getSideMenuIsActive: (state) => state.sideMenuIsActive,
    getBackdropIsActive: (state) => !!state.backdropOpenedTimes,
    getChatIsOpened: (state) => state.chatIsOpened,
    getModalIsOpened: (state) => state.modalIsOpened,
  },
  mutations: {
    setSoundIsMuted: (state, isMuted) => (state.soundIsMuted = isMuted),
    setSideMenuIsActive: (state, value) => (state.sideMenuIsActive = value),
    incrementBackdrop: (state) => state.backdropOpenedTimes++,
    decrementBackdrop: (state) => state.backdropOpenedTimes--,
    setChatIsOpened: (state, value) => (state.chatIsOpened = value),
    setModalIsOpened: (state, value) => (state.modalIsOpened = value),
  },
  actions: {
    applySoundIsMuted: ({ commit }, isMuted) => {
      const numericIsMuted = (isMuted ? 1 : 0).toString();

      localStorage.setItem('soundIsMuted', numericIsMuted);
      commit('setSoundIsMuted', isMuted);
    },
    showSideMenu: ({ commit }) => {
      commit('incrementBackdrop');
      commit('setSideMenuIsActive', true);
    },
    hideSideMenu: ({ commit }) => {
      commit('decrementBackdrop');
      commit('setSideMenuIsActive', false);
    },
    toggleSideMenu: ({ dispatch, getters }) => {
      getters.getSideMenuIsActive ? dispatch('hideSideMenu') : dispatch('showSideMenu');
    },
  },
};
